import React from "react";

// import { BsFileLock } from "react-icons/bs";
import { Link } from "react-router-dom";

const ForbiddenRoute = () => {
  return (
    <div>
      <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
        <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
          <div className="relative">
            <div className="absolute">
              <div className="">
                <h1 className="my-2 text-left text-gray-800 font-bold text-2xl">
                  Looks like you don't have a permission to view this page
                </h1>
                <p className=" text-left my-2 text-gray-800">
                  Sorry about that! Please visit the Home Page or contact the{" "}
                  <a href="mailto:pex.people.insights@autodesk.com?subject=Requesting%20Access%20in%20the%20People%20Insights%20Portal">
                    People Insights Team{" "}
                  </a>
                </p>
                <button className="sm:w-full lg:w-auto my-2 border rounded md py-4 px-8 text-center bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-opacity-50">
                  <Link to="/">Take me Home!</Link>
                </button>
              </div>
            </div>
            <div>
              {/* <img src={lock} /> */}
              {/* <BsFileLock size={300} color="white" /> */}
            </div>
          </div>
        </div>
        <div>
          {/* <BsFileLock size={100} /> */}
        </div>
      </div>
    </div>
  );
};

export default ForbiddenRoute;
